/* eslint-disable react/jsx-no-target-blank */
import {SidebarMenuTabsItem} from '../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuTabsItem'
import {SidebarMenuItemWithSub} from '../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItemWithSub'
import {useLavanderia} from '../../../../hooks/useLavanderia'
import {useHoteleria} from '../../../../hooks/useHoteleria'
import {TabLavanderiaModel} from '../../../../models'
import {SidebarMenuItem} from '../../../../../../_metronic/layout/components/sidebar/sidebar-menu/SidebarMenuItem'
import {useCentral} from '../../../../hooks/useCentral'
const SidebarMenuLavanderia = () => {
  const {addTab, changeTab, menu, tabs} = useLavanderia()
  const {addTab: addTabHoteleria, changeTab: changeTabHoteleria, tabs: tabsHoteleria} = useHoteleria()
  const {changeTab: changeTabCentral, addTab: addTabCentral, tabs: tabsCentral} = useCentral()

  const addTabToContainer = (tab: TabLavanderiaModel) => {
    // Verificar si ya existe una pestaña con el mismo submenu
    const existingTabIndex = tabs.findIndex(
      (existingTab) => existingTab.submenu === tab.submenu && existingTab.vista === tab.vista
    )
    
    if (existingTabIndex !== -1) {
      // Si ya existe, simplemente activarla
      changeTab(existingTabIndex)
    } else {
      // Si no existe, agregar una nueva pestaña
      changeTab(addTab(tab))
    }
  }
  
  const addTabToContainerHoteleria = (tab: TabLavanderiaModel) => {
    let obj = {
      id: tab.id,
      title: tab.title,
      showPanel: false,
      content: {
        headerPanel: tab.content.headerPanel,
      },
      closable: true,
      submenu: tab.submenu,
      idToEdit: '',
      loadingTable: false,
      deleted: false,
      updated: false,
      vista: tab.vista,
      fromOtherApp: true,
    }
    
    // Verificar si ya existe una pestaña con el mismo submenu en Hotelería
    const existingTabIndex = tabsHoteleria.findIndex(
      (existingTab) => existingTab.submenu === obj.submenu && existingTab.vista === obj.vista
    )
    
    if (existingTabIndex !== -1) {
      // Si ya existe, simplemente activarla
      changeTabHoteleria(existingTabIndex)
    } else {
      // Si no existe, agregar una nueva pestaña
      changeTabHoteleria(addTabHoteleria(obj))
    }
  }

  const addTabToContainerCentral = (tab: any) => {
    let obj = {
      id: tab.id,
      title: tab.title,
      showPanel: false,
      content: {
        headerPanel: tab.content.headerPanel,
      },
      opciones: tab.opciones,
      closable: true,
      submenu: tab.submenu,
      idToEdit: '',
      loadingTable: false,
      deleted: false,
      updated: false,
      vista: tab.vista,
      fromOtherApp: true,
    }
    
    // Verificar si ya existe una pestaña con el mismo submenu en Central
    const existingTabIndex = tabsCentral.findIndex(
      (existingTab) => existingTab.submenu === obj.submenu && existingTab.vista === obj.vista
    )
    
    if (existingTabIndex !== -1) {
      // Si ya existe, simplemente activarla
      changeTabCentral(existingTabIndex)
    } else {
      // Si no existe, agregar una nueva pestaña
      changeTabCentral(addTabCentral(obj))
    }
  }
  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>LAVANDERIA</span>
        </div>
      </div>
      {menu &&
        menu.length > 0 &&
        menu.map((item) => {
          const existOption = item.opciones ? true : false
          const canList =
            existOption && item?.opciones.some((item: any) => item.opcion === 'ACCESO')
          const isShow = canList
          if (!isShow) return <></>
          return (
            <SidebarMenuItemWithSub
              key={item.id}
              to='/crafted/accounts'
              title={item.name}
              icon='/media/icons/duotune/communication/com006.svg'
              fontIcon='bi-person'
            >
              {item.key === 'vdi'
                ? item.arraySubItem.map((subItem: any) =>
                    subItem.path === '/hoteleria' ? (
                      <SidebarMenuItem
                        key={subItem.id}
                        to={subItem.path}
                        title={subItem.title}
                        hasBullet={true}
                        onClickHandler={() => addTabToContainerHoteleria(subItem)}
                      />
                    ) : (
                      <SidebarMenuItem
                        key={subItem.id}
                        to={subItem.path}
                        title={subItem.title}
                        hasBullet={true}
                        onClickHandler={() => addTabToContainerCentral(subItem)}
                      />
                    ),
                  )
                : item.arraySubItem.map((subItem: any) => {
                    const existOption = subItem.opciones ? true : false
                    const canList =
                      existOption && subItem?.opciones.some((item: any) => item.opcion === 'ACCESO')
                    const isShow = canList
                    if (!isShow) return <></>
                    return (
                      <SidebarMenuTabsItem
                        key={subItem.id}
                        to='/lavanderia/clientes'
                        title={subItem.title}
                        hasBullet={true}
                        onClickHandler={() => addTabToContainer(subItem)}
                      />
                    )
                  })}
            </SidebarMenuItemWithSub>
          )
        })}
    </>
  )
}

export {SidebarMenuLavanderia}
